import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import { InputField, LabelField } from "components";
import InfoTooltip from "components/InfoTooltip";
import AlertDialog from "components/Dialog";
import Button from "components/button/Button";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import BottomArrowSvg from "../../../../../src/assets/icons/svg/BottomArrowSvg";
import TypeCheckBoxes from "../PaymentsTypes/PaymentCheckBox";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};

const EditAccountReceivalbe = ({
  formik,
  type,
  addNew,
  edit,
  updateFunc,
  createFunc,
  setEdit,
  setDaisableAddNew,
  setDisable,
  setAddNew,
}) => {
  const localStorageData = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;
  const [search, setSearch] = useState("");
  const [loading, setLoading] = React.useState(false);

  const { getAccessTokenSilently } = useAuth0();
  const { searchAction } = useSearch({ action: setSearch });

  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const { push } = useHistory();
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleCancel = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();
    push({
      pathname: "/financial-setting/accounts-receivable/view",
    });
  };
  const cancelFunc = () => {
    setOpenDisableAlert(true);
  };
  const validateCreateFunc = () => {
    if (!formik.values?.ar_name) {
      return toastr.info("Validation", "Text field is mandatory");
    }
    if (!formik.values?.ar_id && (isProgramOnline || isProgramSage)) {
      return toastr.info("Validation", "Text field is mandatory");
    }
    
    createFunc();
    // push({
    //   pathname: "/accounts-receivable/view",
    // });
  };
  const validateUpdateFunc = () => {
    if (!formik.values?.ar_name) {
      return toastr.info("Validation", "Text field is mandatory");
    }
    if (!formik.values?.ar_id && (isProgramOnline || isProgramSage)) {
      return toastr.info("Validation", "Text field is mandatory");
    }

    updateFunc({
      ar_name: formik.values?.ar_name ? formik.values?.ar_name : undefined,
      ar_id: (isProgramOnline || isProgramSage) ? formik.values?.ar_id : undefined,
    });
    push({
      pathname: "/financial-setting/accounts-receivable/view",
    });
  };

  //hanlde queryBoxes

  const [bol, setBol] = useState(1);
  const [queryResponse, setQueryResponse] = useState([]);
  const [selectedQuery, setSelectedQuery] = useState({
    Id: "",
    Name: "",
  });

  useEffect(() => {
    if (
      formik?.values?.ar_id &&
      addNew === false &&
      queryResponse?.length > 0
    ) {
      const object = queryResponse.find(
        (obj) => obj.value === formik?.values?.ar_id
      );
      setSelectedQuery({
        Id: object?.value,
        Name: object?.label,
      });
    }
  }, [formik?.values?.ar_id, queryResponse]);

  useEffect(() => {
    if (
      localStorageData?.quickBooks_information?.program === "online" &&
      bol === 1
    ) {
      getQuickBooksURL();
      setBol(2);
    }
  }, [localStorageData]);

  const getQuickBooksURL = async (row) => {
    const token = await getAccessTokenSilently();
    await FinanceService.GetDepositQuickbooks(token).then((res) => {
      if (res?.result?.authenticated === true) {
        // createNewDeposit(row);
        getAccountListForQB();
      } else {
        window.open(
          res?.result?.url,
          "_blank",
          "toolbar=0,location=0,menubar=0"
        );
        push({
          pathname: "/financial-setting",
        });
      }
    });
  };

  const handleQueryArray = (value) => {
    setSelectedQuery({
      Id: value.value,
      Name: value.label,
    });
    formik.setFieldValue(`ar_id`, value.value);
  };

  const getAccountListForQB = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.GetListOfAccountForQB(
      "Accounts Receivable",
      token
    )
      .then((res) => {
        const data = res?.result?.QueryResponse?.Account?.map(
          (item, index) => ({
            value: item?.Id,
            label: item?.Name,
          })
        );
        setQueryResponse(data);
        // setReceivableAccounts(res?.result);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const isProgramSage = localStorageData?.quickBooks_information?.program === "sage";
  const isProgramOnline = localStorageData?.quickBooks_information?.program === "online";

  return (
    <>
      <div className="d-flex justify-content-end pb-5 pr-15">
        <AlertDialog
          open={openDisableAlert}
          handleClose={handleCloseDialog}
          onDecline={() => {
            setOpenDisableAlert(false);
          }}
          onAccept={handleCancel}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
        <Button 
          onClick={cancelFunc}
          variant="primary-outline"
          size="md"
          style={{ minWidth: 80 }}
        >
          Cancel
        </Button>
        <Button
          className="ml-5"
          onClick={addNew == true ? validateCreateFunc : validateUpdateFunc}
          variant="primary"
          size="md"
          style={{ minWidth: 80 }}
        >
          Save
        </Button>
      </div>
      <div className="pl-5 ml-5 d-flex ">
        <div className="col-md-4">
          <InputField
            mandatory={true}
            {...{
              formik,
              name: "ar_name",
              title: isProgramSage ? "Sage Name" : "Accounts Receivable Name",
            }}
            value={formik.values?.ar_name}
            style={{ height: "48px" }}
          />
        </div>
        {(isProgramOnline || isProgramSage) && (
          <>
            {queryResponse?.length > 0 ? (
              <>
                <div className="col-md-4">
                  <LabelField mandatory title={isProgramSage ? "Sage Name" : "QuickBooks Name"} hint="Links this record to the matching Accounts Receivable account in your connected accounting software (QuickBooks/Sage)." />
                  <Select
                    {...{
                      formik,
                      name: `account_receivable`,
                      checkValidation: false,
                    }}
                    onInputChange={(text) => searchAction(text)}
                    classNamePrefix="react-select"
                    formatOptionLabel={formatOptionLabel}
                    options={queryResponse}
                    isLoading={loading}
                    styles={colourStyles}
                    onChange={(value) => handleQueryArray(value)}
                    value={
                      selectedQuery
                        ? {
                            label: selectedQuery?.Name,
                            value: selectedQuery?.Id,
                          }
                        : ""
                    }
                    components={{ DropdownIndicator }}
                    isDisabled={false}
                  />
                </div>
                <div className="col-md-4">
                  <InputField
                    mandatory={true}
                    {...{
                      formik,
                      name: "ar_id",
                      title:"QuickBooks ID",
                      disabled: true
                    }}
                    value={formik.values?.ar_id}
                    style={{ height: "48px" }}
                  />
                </div>

              </>
            ) : (
              <div className="col-md-4">
                <InputField
                  mandatory={true}
                  {...{
                    formik,
                    name: "ar_id",
                    title: isProgramSage ? "Sage ID" : "QB Account Receivable ID:",
                  }}
                  value={formik.values?.ar_id}
                  style={{ height: "48px" }}
                />
              </div>

            )}
          </>
        )}
      </div>
    </>
  );
};

export default EditAccountReceivalbe;
